exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.theme--light.v-btn:not(.v-btn--round).v-size--default.add-user-btn[data-v-a7e39042] {\n  padding: 8px 16px;\n}\n", ""]);
